module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-testimonials"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__wrapper"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-testimonials__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), _c('router-link', {
    staticClass: "custom-home-testimonials__btn",
    attrs: {
      "to": "/why-choose-us#before-after"
    }
  }, [_vm._v(" Before and Afters")]), _c('div', {
    staticClass: "custom-home-testimonials__gallery-container"
  }, [_vm._l((_vm.props.gallery), function(circle, i) {
    return (i < 6) ? _c('div', {
      directives: [{
        name: "random-size",
        rawName: "v-random-size"
      }],
      key: i,
      staticClass: "custom-home-testimonials__gallery-item",
      on: {
        "click": function($event) {
          return _vm.openTestiModial(circle.src)
        }
      }
    }, [_c('div', {
      staticClass: "custom-home-testimonials__gallery-item-background",
      style: ({
        backgroundImage: 'url(' + circle.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-home-testimonials__gallery-item-overlay",
      domProps: {
        "innerHTML": _vm._s(circle.text)
      }
    }), _c('Icon', {
      staticClass: "custom-home-testimonials__play-btn",
      attrs: {
        "name": "triangle"
      }
    })], 1) : _vm._e()
  }), _c('transition-group', {
    staticClass: "custom-home-testimonials__modal-transition",
    attrs: {
      "name": "fade-in-out",
      "tag": "div"
    }
  }, _vm._l((_vm.props.gallery), function(circle2, j) {
    return (j >= 6 && _vm.galleryLoaded) ? _c('div', {
      directives: [{
        name: "random-size",
        rawName: "v-random-size"
      }],
      key: j,
      staticClass: "custom-home-testimonials__gallery-item",
      on: {
        "click": function($event) {
          return _vm.openTestiModial(circle2.src)
        }
      }
    }, [_c('div', {
      staticClass: "custom-home-testimonials__gallery-item-background",
      style: ({
        backgroundImage: 'url(' + circle2.image + ')'
      })
    }), _c('div', {
      staticClass: "custom-home-testimonials__gallery-item-overlay",
      domProps: {
        "innerHTML": _vm._s(circle2.text)
      }
    }), _c('Icon', {
      staticClass: "custom-home-testimonials__play-btn",
      attrs: {
        "name": "triangle"
      }
    })], 1) : _vm._e()
  }), 0)], 2), (_vm.props.gallery.length >= 6 && !_vm.buttonHidden) ? _c('div', {
    staticClass: "custom-home-testimonials__btn",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(" Load More")]) : _vm._e(), _c('div', {
    staticClass: "custom-home-testimonials__review-container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__review-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.review.title)
    }
  }), _c('div', {
    staticClass: "custom-home-testimonials__review-row"
  }, _vm._l((_vm.props.review.reviews), function(item, i) {
    return _c('a', {
      key: i,
      staticClass: "custom-home-testimonials__review-item",
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      staticClass: "custom-home-testimonials__review-stars",
      attrs: {
        "name": "stars"
      }
    }), _c('img', {
      staticClass: "custom-home-testimonials__review-logo",
      attrs: {
        "title": item.image.title,
        "src": item.image.url,
        "alt": item.image.alt
      }
    })], 1)
  }), 0), _c('Icon', {
    staticClass: "custom-home-testimonials__review-icon",
    attrs: {
      "name": "star"
    }
  }), _vm._m(0)], 1)], 1), _c('transition', {
    staticClass: "custom-home-testimonials__modal-transition",
    attrs: {
      "name": "fade-in-out"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalActive),
      expression: "modalActive"
    }],
    staticClass: "custom-home-testimonials__modal"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__modal-overlay",
    on: {
      "click": _vm.closeTestiModial
    }
  }, [_c('div', {
    staticClass: "custom-home-testimonials__modal-container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__modal-close",
    on: {
      "click": _vm.closeTestiModial
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "custom-home-testimonials__modal-content"
  }, [_c('video', {
    ref: "video",
    staticClass: "custom-home-testimonials__video",
    attrs: {
      "src": _vm.videoTestimonial,
      "type": "video/mp4",
      "controls": "controls",
      "controlsList": "nodownload"
    }
  }, [_vm._v("Your browser doesn't support HTML5 video. ")])])])])])])], 1), _c('Icon', {
    staticClass: "custom-home-testimonials__social-mask",
    attrs: {
      "name": "social-top-white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-testimonials__review-bottom"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__review-cta-title phonewrapp"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__review-cta-container"
  }, [_c('p', {
    staticClass: "text-centerr"
  }, [_vm._v("Schedule a New Patient Adult or Child Braces/Clear Aligners Exam")])])]), _c('div', {
    staticClass: "custom-home-testimonials__appointments-container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__appointments_newbtns"
  }, [_c('a', {
    staticClass: "custom-home-testimonials__ortho-consult",
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=psnnsi",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Schedule a new patient consult for adult Braces/Aligners")])]), _c('a', {
    staticClass: "custom-home-testimonials__ortho-consult",
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=sbsxfy",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Schedule a new patient consult for Kids Braces")])])])]), _c('div', {
    staticClass: "custom-home-testimonials__review-cta-title phonewrapp"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__review-cta-container btn_appointlast"
  }, [_c('p', {
    staticClass: "text-centerr"
  }, [_vm._v("For new patient pediatric dental appointments please call  ")])])]), _c('div', {
    staticClass: "custom-home-testimonials__appointments-container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__appointments_newbtns phonenew"
  }, [_c('a', {
    staticClass: "custom-home-testimonials__ortho-consult",
    attrs: {
      "href": "tel:1-630-980-8800"
    }
  }, [_c('span', [_vm._v("(630) 980-8800                                                             ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a86f340","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-testimonials/custom-home-testimonials.pug
// module id = 689
// module chunks = 1